import React from 'react'
import { STATICS } from 'statics'
import { DEFAULT_CONTACT_NUMBER } from 'app-constants'
import './style.scss'

export function AfterTime() {
  return (
    <div className='container-after-time'>
      <div className='container-icon'>
        <STATICS.INFO />
      </div>
      <div className='container-info'>
        <span className='info'>
          Caro cliente, nosso canal de atendimento via chat funciona todos os dias de 6h às 00h,
          para falar com um de nossos atendentes ligue para{' '}
          <span className='number'>{DEFAULT_CONTACT_NUMBER}</span>
        </span>
      </div>
    </div>
  )
}
